import Vue from 'vue'
import store from '../store'
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'
import tagularHelper from '../tagular'
import uuidv4 from 'uuid/v4'
import ccHubArticles from './components/cc-hub-articles/cc-hub-articles'
import tooltip from '../common/tooltip'
import resource from '../resources'
import velocityAnim from '../common/VelocityAnim'

new Vue({
  el: '#credit-card-hub',
  store,
  components: {
    ccHubArticles
  },
  created() {
    window.Ziggy.baseUrl = window.Ziggy.baseUrl.slice(0, -1)
  }
})

new Vue({
  el: '#credit-card-hub-goals',
  store,
  components: {
    tooltip,
    velocityAnim
  },
  data() {
    return {
      showAllCards: false
    }
  },
  computed: {
    ...mapGetters(['isMobile', 'correlationId'])
  },
  created() {
    window.Ziggy.baseUrl = window.Ziggy.baseUrl.slice(0, -1)
    this.setCorrelationId(uuidv4())

    resource.mediaQueries.forEach(item => {
      item.query.addListener(e => {
        if (e.media === item.query.media) {
          this.updateBreakpoint(item.type)
        }
      })
    })
  },
  mounted() {
    const match = _.findLast(resource.mediaQueries, query => {
      return query.query.matches
    })

    if (match) {
      this.updateBreakpoint(match.type)
      return
    }

    this.updateBreakpoint(resource.mediaQueries[0].type)
  },
  methods: {
    ...mapActions(['updateBreakpoint', 'setCorrelationId']),
    tagularTrack(
      location,
      position,
      text,
      elementType,
      htmlId,
      actionOutcome,
      outboundUrl
    ) {
      tagularHelper.elementClicked(
        {
          location,
          position,
          elementType,
          text,
          htmlId
        },
        actionOutcome,
        outboundUrl,
        this.correlationId
      )
    },
    trackClicks(e) {
      this.tagularTrack(
        e.dataset.location,
        e.dataset.position,
        e.dataset.text,
        e.dataset.elementType,
        e.dataset.htmlId,
        e.dataset.actionOutcome,
        e.dataset.outboundUrl
      )
      store.dispatch('setCorrelationId', uuidv4())
    },
    seeMoreToggle(e) {
      this.showAllCards = !this.showAllCards
      this.trackClicks(e)
    },
    trackHeroLinks(e) {
      ga('t01.send', 'event', 'Credit-Card-Funnel-Page', e.dataset.title)
      this.trackClicks(e)
    }
  }
})
